import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
import { AutoMetricField } from "../../core";
import { useAutoMetricContext } from "./useAutoMetricContext";
/**
 * Push parameters to given metric node
 */
export var useAutoMetricNodeParams = function useAutoMetricNodeParams(node) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  useEffect(function () {
    var fields = Object.entries(typeof params === 'function' ? params() : params).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];
      return new AutoMetricField(name, value);
    });
    return node.register.apply(node, _toConsumableArray(fields));
  }, [node, params]);
};

/**
 * Push parameters to the closest metric nodes
 */
export var useAutoMetricParams = function useAutoMetricParams(params) {
  var _useAutoMetricContext = useAutoMetricContext(),
    node = _useAutoMetricContext.node;
  useAutoMetricNodeParams(node, params);
};